import { TagChip, TagChipColor, TagIcon } from '@st/theme'

import { FolderTag } from '@st/sdk/src/sdk.types'
import { isNotEmpty } from '@st/util/json-value'
import { ReactNode } from 'react'

export function FolderTagsList({
  leading,
  folderTags,
  tagIds,
  onClick
}: {
  leading?: ReactNode
  folderTags: FolderTag[]
  tagIds: string[]
  onClick?: () => void
}) {
  const tags = tagIds.map((tid) => folderTags.find((t) => t.id == tid)).filter(isNotEmpty)

  return (
    <div className="flex flex-row gap-1" onClick={onClick}>
      {leading}
      {tags.map((t) => {
        return (
          <TagChip key={t.id} color={t.color as TagChipColor} onClick={onClick}>
            {t.label}
          </TagChip>
        )
      })}
    </div>
  )
}
import { forwardRef } from 'react'

export const FolderTagsListEditButton = forwardRef<
  HTMLButtonElement,
  {
    onClick: () => void
    className?: string
  }
>(({ onClick, className }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      aria-label="Edit folder tags"
      className="invisible hover:text-blue-500 group-hover:visible"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        onClick()
      }}
    >
      <TagIcon className="h-4 w-4" aria-hidden="true" />
    </button>
  )
})
